import { request } from "../http/api-client";

export type MeResponse = {
  success: boolean;
  data: {
    user: {
      id: string;
      email: string;
      fullName: string;
      phone?: string | null;
      role: string;
      isActive: boolean;
      emailVerified: boolean;
      createdAt: string;
      updatedAt: string;
      lastLoginAt: string | null;
      merchantUsers?: Array<{
        id: string;
        merchantId: string;
        role: string;
        createdAt: string;
        updatedAt: string;
        merchant?: { id: string; name: string; status: string };
      }>;
      merchantId?: string;
    };
  };
};

export async function getMe() {
  const res = await request<MeResponse>("/api/v1/auth/me", { method: "GET" });
  return res.data.user;
}

export async function updateMe(payload: { fullName?: string; phone?: string; email?: string }) {
  const res = await request<{ success: boolean; data: { updated: boolean } }>("/api/v1/auth/me", {
    method: "PUT",
    body: payload,
  });
  return res.data.updated;
}
